/**
 * Auth Footer component for the SCAD system
 * Used in authentication-related pages like Login and CompanyRegister
 */

import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.div`
  margin-top: 2rem;
  padding: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.9rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  
  a {
    color: #4285F4;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.2s ease, transform 0.2s ease;
    display: inline-block;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    background-color: rgba(66, 133, 244, 0.1);
    margin-left: 0.5rem;
    
    &:hover {
      color: #5c9aff;
      background-color: rgba(66, 133, 244, 0.2);
      transform: translateY(-1px);
    }
    
    &:active {
      transform: translateY(0);
    }
  }
  
  .copyright {
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.5);
    margin-top: 0.5rem;
  }
`;

const AuthFooter = ({ children }) => {
  return (
    <FooterContainer>
      {children}
    </FooterContainer>
  );
};

export default AuthFooter;
